import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import CourseDetail from "./components/CourseDetail";
import Login from "./pages/Login";
import ManageCourses from "./pages/ManageCourses";
import Enrollments from "./pages/Enrollments";
import Courses from "./components/Courses";
import HomeSettings from "./pages/HomeSettings";
import Navbar from "./components/Navbar";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import AdminAddBlog from "./pages/AdminAddBlog";
import EditBlog from "./pages/EditBlog";
import BlogDetails from "./pages/BlogDetails";

import "./App.css";
import ScrollToTop from "./pages/ScrollToTop";

function App() {
  return (
    <Router basename="/">
      <ScrollToTop />
      <Routes>
        {/* ================= HOME + SEO SECTION ROUTES ================= */}

        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<HomePage />} />
        <Route path="/why-swiftintelli" element={<HomePage />} />
        <Route path="/contact-us" element={<HomePage />} />
        <Route path="/training" element={<HomePage />} />

        {/* ================= LOGIN ================= */}

        <Route path="/login" element={<Login />} />

        {/* ================= BLOG ================= */}

        <Route path="/blog" element={<Blog />} />

        <Route path="/blog/:slug" element={<BlogDetails />} />

        {/* ================= CONTACT PAGE ================= */}

        <Route path="/contact" element={<Contact />} />

        {/* ================= COURSES ================= */}

        <Route path="/our-courses" element={<HomePage />} />

        {/* COURSE DETAIL */}
        <Route path="/course/:slug" element={<CourseDetail />} />

        {/* ================= ADMIN ================= */}

        <Route path="/manage-courses" element={<ManageCourses />} />

        <Route path="/enrollments" element={<Enrollments />} />

        <Route
          path="/home-settings"
          element={
            <>
              <Navbar />
              <HomeSettings />
            </>
          }
        />

        {/* ================= BLOG ADMIN ================= */}

        <Route path="/admin-add-blog" element={<AdminAddBlog />} />

        <Route path="/edit-blog/:id" element={<EditBlog />} />

        {/* ================= 404 PAGE ================= */}

        <Route
          path="*"
          element={
            <div
              style={{
                textAlign: "center",
                marginTop: "120px",
                fontSize: "32px",
                fontWeight: "600",
              }}
            >
              Page Not Found ❌
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
